import { gql, NetworkStatus, useQuery } from '@apollo/client';

import { WithdrawSoftBlock } from './index.types';
import { useEffect, useState } from 'react';

const query = gql`
  query WithdrawSoftBlock {
    currentUser {
      clearingWithdrawSoftBlock {
        expirationDate
      }
    }
  }
`;

const WAITING_TIME = 1000;

export function useWithdrawSoftBlock() {
  const [isWaitingTimePassed, setIsWaitingTimePassed] = useState(false);
  const [waitingTimeout, setWaitingTimeout] = useState<ReturnType<typeof setTimeout>>();
  const { data, loading, networkStatus } = useQuery<WithdrawSoftBlock>(query, {
    skip: isWaitingTimePassed,
  });

  useEffect(() => {
    setWaitingTimeout(
      setTimeout(() => {
        setIsWaitingTimePassed(true);
      }, WAITING_TIME)
    );
    return () => {
      if (waitingTimeout) clearTimeout(waitingTimeout);
    };
  }, []);

  const softBlock = data?.currentUser?.clearingWithdrawSoftBlock;
  const isBlocked = Boolean(softBlock);
  const expirationDate = softBlock?.expirationDate;

  const isExecuted = networkStatus === NetworkStatus.ready || networkStatus === NetworkStatus.error;
  if (isExecuted && waitingTimeout) {
    clearTimeout(waitingTimeout);
  }

  return { expirationDate, isBlocked, loading };
}
